import { Shop } from 'shared-model'

export interface ShopState {
    shop: Shop
}

export enum ShopsMutation {
    SET_SHOP = 'setShop'
}